import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { DossierSandboxService } from '@sc/data-access-state-management';
import { AuthService } from '@sc/feature-auth-okta';
import { InsurerRouterService } from '@sc/feature-insurer-path-router-system';
import { DeclarationConditions } from '@sc/utils';
import { combineLatest, map, take } from 'rxjs';

export const CustomerDataFormGuardCanActivate: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const insurerRouterService = inject(InsurerRouterService);
  const declarationConditions = inject(DeclarationConditions);

  const dossierSB = inject(DossierSandboxService);
  return combineLatest([
    authService.userIsInsurer$(),
    insurerRouterService.getRedirectRoute(),
    dossierSB.dossier$,
  ]).pipe(
    take(1),
    map(([isInsurer, redirectUrl, dossier]) => {
      if (
        !!dossier &&
        isInsurer &&
        !declarationConditions.canEditB2BDossierAfterApiCreation(dossier)
      ) {
        return router.parseUrl('/declaration/intervention');
      }
      return isInsurer ? true : router.parseUrl(redirectUrl);
    })
  );
};
